module.exports = __webpack_public_path__ + "23eb537a2c2313196a8caa8db8ca95b9.png";